import { Box } from '@mui/material';
import { useState } from 'react';
import useFetchApiData from '../../../core/hooks/useFetchApiData';
import Layout from '../../../core/ui/layout/Layout';
import TableContainer from '../../../core/ui/table/TableContainer';
import { TableHeader } from '../../../core/ui/table/tableTypes';
import { Media, Paginated } from '../../../core/utils/types';
import { parseQuery } from '../../../core/utils/utility';
import { Publication } from '../publication';
import { useSendApiData } from '../../../core/hooks/useSendApiData';
import { toastError, toastMessage } from '../../../core/utils/ui/alert';
import ImagePreview from '../../../core/ui/utility/ImagePreview';

const tableHeaders: TableHeader[] = [
  { field: 'title', label: 'Title', align: 'left' },
  { field: 'description', label: 'Description', align: 'left' },
  { field: 'type', label: 'Type', align: 'left' },
  {
    field: 'media',
    label: 'Image',
    align: 'left',
    renderItem: (item: Media[]) => (
      <ImagePreview
        media={item.filter((i) => i.mime_type.startsWith('image'))}
      />
    ),
  },
];
const PublicationList = () => {
  const [data, setData] = useState<Record<string, any>[]>([]);
  const { fetchData } = useFetchApiData();
  const { callApi } = useSendApiData();

  const handleFetchData = async (query: any, cb: (c: number) => void) => {
    await fetchData(`publications${parseQuery(query)}`, {
      onSuccess: ({ total, data: apiData }: Paginated<Publication>) => {
        setData(apiData);
        cb(total);
      },
    });
  };

  const handleDelete = async (id: number | string, showMessage = true) => {
    let success = false;

    await callApi({
      endpoint: `auth-ecff80/publications/${id}`,
      data: {},
      method: 'delete',
      onSuccess: async () => {
        if (showMessage) toastMessage('Item Removed');
        success = true;
      },
      onError: () => {
        if (showMessage)
          toastError('Something went wrong while deleting. Try again');
      },
    });

    return success;
  };

  return (
    <>
      <Layout>
        <Box sx={{ p: 2, maxWidth: 1200 }}>
          <TableContainer
            modelToken="publications"
            tableHeaders={tableHeaders}
            data={data}
            modelLabel="Publications"
            actions={{
              onFetchData: handleFetchData,
              onDelete: handleDelete,
            }}
            routes={{
              edit: '/publications/edit',
              create: '/publications/create',
              delete: '/publications',
              view: '/publications',
            }}
            settings={{
              canCreate: true,
              canEdit: true,
              canDelete: true,
              canViewItem: false,
            }}
          />
        </Box>
      </Layout>
    </>
  );
};

export default PublicationList;
